import type { FunctionReturnType } from 'convex/server'
import type { api } from '../../convex/_generated/api'

export type ExternalPrescriptionDocument = NonNullable<FunctionReturnType<typeof api.externalLabs.getPrescription>>

/** Generate locally; patient data is never sent to a PDF service. */
export async function downloadExternalPrescriptionPdf(record: ExternalPrescriptionDocument): Promise<void> {
  const [{ renderExternalPrescriptionPdf }, ...assets] = await Promise.all([
    import('./renderExternalPrescriptionPdf'),
    import('@fontsource/roboto/files/roboto-latin-400-normal.woff?url'),
    import('@fontsource/roboto/files/roboto-latin-ext-400-normal.woff?url'),
    import('@fontsource/roboto/files/roboto-cyrillic-400-normal.woff?url'),
    import('@fontsource/roboto/files/roboto-greek-400-normal.woff?url'),
  ])
  const fonts = await Promise.all(assets.map(async ({ default: url }) => {
    const response = await fetch(url)
    if (!response.ok) throw new Error('Impossibile caricare il carattere per il PDF. Riprova.')
    return new Uint8Array(await response.arrayBuffer())
  }))
  const bytes = await renderExternalPrescriptionPdf(record, fonts)
  const url = URL.createObjectURL(new Blob([new Uint8Array(bytes)], { type: 'application/pdf' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `${record.number.replace(/[^a-z0-9_-]/gi, '_')}.pdf`
  document.body.append(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 30_000)
}
